import React from 'react'
import SALink from 'components/SALink'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import { ShortcutsSubMenu } from './styles'
import { SUB_MENU_DATA } from '../../helpers/constants'
import { updateTradeUrl } from '../../helpers/url'
type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <ShortcutsSubMenu data-type='shortcuts'>
      {SUB_MENU_DATA.map(({ url, title, page }, index) => (
        <button
          type='button'
          data-section={page}
          key={index}
          {...(section === page
            ? {
                'data-style': 'hide',
              }
            : {})}
        >
          <SALink href={url} title={title}>
            {title}
          </SALink>
        </button>
      ))}
    </ShortcutsSubMenu>
  )
}

export default Component
